export default "__VITE_ASSET__cc89aae9__"